<template>

	<div id="content" class="content learning-test p-t-0" oncontextmenu="return false" ondragstart="return false" onselectstart="return false">
		<div class="container">
			<div class="learning-close">
				<div class="close-box" @click="doClose"></div>
			</div>
			<div class="learning-title p-t-5 p-b-5">
				<div class="inner">
					<div class="thumb-box" :style="'background-image: url(' + eduMain.thumbnail + ');'"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim" v-if="eduMain.cateCodeVO != null">{{ eduMain.cateCodeVO.codeName }}</span>
							<span class="sec" v-if="eduMain.isMajor">주요</span>
						</div>
						<h2 class="tit" v-html="eduMain.eduTitle"></h2>
						<div class="info" v-if="!$options.filters.isEmpty(eduMain.startDate) && !$options.filters.isEmpty(eduMain.endDate)">
							<div class="info-row">
								<strong>학습기간</strong>
								<div>{{ eduMain.startDate | scheduleFilter }} - {{ eduMain.endDate | scheduleFilter }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<template v-if="contentList[step] != null">

				<!-- 교육 영상자료 -->
				<ans-mov v-if="contentList[step].contentType === 'mov'" :eduMain="eduMain" :edu-content="contentList[step]" :edu-answer="answerList[step]" @goPrev="goPrev" @goNext="goNext"></ans-mov>


				<!-- 파일 교육 -->
				<ans-file v-if="contentList[step].contentType === 'file'" :eduMain="eduMain" :edu-content="contentList[step]" :edu-answer="answerList[step]" @goPrev="goPrev" @goNext="goNext"></ans-file>


				<!-- 테스트 문항 -->
				<ans-tst v-if="contentList[step].contentType === 'tst' " :edu-main="eduMain" :edu-content="contentList[step]" :edu-answer="answerList[step]" @goPrev="goPrev" @goNext="goNext" ></ans-tst>

			</template>


			<!--			<div class="learning-content">
							<div class="inner">
								<div class="test-start">
									<h3>테스트는 총 10문항 입니다.</h3>
									<p>'테스트 시작' 버튼을 누르면 테스트가 시작됩니다. 테스트 도중에는 중단할 수 없습니다.</p>
									<a href="#" class="btn btn-lg btn-primary">테스트 시작</a>
								</div>
							</div>
						</div>-->


		</div>
	</div>

</template>

<script>
import Qs from "qs";
import AnsMov from "@/components/educations/answer/ansMov";
import AnsFile from "@/components/educations/answer/ansFile";
import AnsTst from "@/components/educations/answer/ansTst";

export default {
	name: "eduProceed",
	components: {AnsTst, AnsFile, AnsMov},
	data() {

		let playStep = "";
		if ( !this.stringUtils.isEmpty(this.$route.query.playStep) ) {
			playStep = this.stringUtils.valInt(this.$route.query.playStep)
		}

		return {

			emIdx: this.$route.params.emIdx,
			userIdDec: atob(this.$route.params.userIdEnc),

			// 교육컨텐츠 정보
			eduMain: new this.EduMainVO(),
			studentVO: {},
			contentList: [],
			answerList: [],

			step: 0,
			playStep,
		}
	},
	created() {

		if ( this.isLogin() && this.getLoginId() === this.userIdDec ) {
			this.getEduMain( this.emIdx, this.getLoginId() );
			this.getAnswers( this.emIdx, this.getLoginId() );
		} else {

			// 로그인 강제 이동
			this.goLogin()
			/*this.swalUtils.fire( "로그인 후 사용가능합니다.", "로그인 화면으로 이동합니다.", "warning" )
			.then((result) => {
				let temp = location.pathname + "?" + Qs.stringify( this.$route.query )
				location.href = "/member/login?referrer=" + encodeURIComponent(temp);
			})*/
		}

		window.eduView = this

	},
	mounted() {

	},
	methods: {

		getEduMain (_emIdx, _userId) {

			var self = this

			self.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(this, this.APIs.EDU_MAIN + "/getEduMain", {
				emIdx : _emIdx,
				userId : _userId,
			}, function (res) {
				const result = res.data
				console.log(result)
				if ( result.status === "ok" ) {
					self.eduMain = result.eduMain
				}
				//console.log("allContentCnt ::::: " + self.allContentCnt)
				self.$eventBus.$emit("doneProgress", 1)
			})

		},


		/**
		 * 이수자의 현재까지 이수정보 조회
		 * @param _emIdx
		 * @param _userId
		 */
		getAnswers (_emIdx, _userId) {

			const self = this;
			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get(this, this.APIs.EDU_ANSWER + "/", {
				emIdx: _emIdx,
				userId: _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 2)

				console.log("getAnswers")
				const result = res.data;
				console.log(result)

				if ( result.status === "ok" ) {

					self.eduMain = result.eduMainVO;
					self.studentVO = self.eduMain.studentVO;
					self.contentList = self.eduMain.contentList;
					self.answerList = result.answerList;

					if ( !self.eduMain.isDisplay ) {
						this.swalUtils.gritter("Error", "공개되지 않은 교육이거나 수정중인 교육입니다.", "danger")
						//alert( "공개되지 않은 교육이거나 수정중인 교육입니다." );
						window.close()
					}

					self.setCurrentAnswer();
				}

			})

		},



		/**
		 * 조회된 이수내용 조회
		 * answerList.length == 0 : 첫단계부터 교육 시작
		 * answerList.length > 0 : 현재 답변 내용 조회 후 이어서 시작.
		 */
		setCurrentAnswer () {

			//console.log("setCurrentAnswer")

			const self = this;
			if ( this.stringUtils.isEmpty( this.playStep ) ) {
				loop: for (let i = 0; i < this.answerList.length; i++) {
					if (this.answerList[i].isComplete) {
						self.step++;
					} else {
						self.step = i;
						break loop;
					}
				}
			} else {
				self.step = this.playStep
			}
			/*this.answerList.forEach(value => {

				if ( value.isComplete ) {
					self.step++;
				}
			})*/

			if ( this.stringUtils.isEmpty(this.playStep) ) {    // 일반 수강화면

				if ( this.step >= this.answerList.length ) {    // 이미 이수된 교육일 경우
					// if ( this.step >= this.answerList.length && this.studentVO.isComplete ) {

					this.swalUtils.fire( "이수가 완료된 교육입니다.", "교육상세 페이지에서 완료처리를 눌러주세요." )
						.then(() => {

							if ( opener != null ) {
								self.appClose({
									reload: true
								})
							} else {
								history.back()
							}

						})

				}
			} else {    // 다시보기일 경우
				this.step = this.playStep
			}

			//console.log("self.step ::::: " + self.step)
		},



		/**
		 * 다음단계 버튼
		 * 컨텐츠 수 내 : 다음단계
		 * 컨텐츠 마지막 : 완료 처리 후 창 닫기
		 */
		goNext () {

			const self = this
			// DONE : answerList 재조회 > 남은 컨텐츠 여부확인
			//this.emIdx, this.getLoginId()
			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get(this, this.APIs.EDU_ANSWER + "/", {
				emIdx: this.emIdx,
				userId: this.getLoginId(),
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 2)

				const result = res.data;
				if ( result.status === "ok" ) {

					let remainContents = false
					result.answerList.forEach(value => {
						if ( !value.isComplete ) {
							remainContents = true
							location.href = location.pathname

							// return 으로 동작시 하단의 self.doContentComplete(); 실행되는 문제 발생
							throw new Error();
						} else {
							remainContents = false;
						}
					})

					if ( !remainContents ) {
						self.doContentComplete();
					}

				}

			})

		},


		doContentComplete () {

			const self = this;

			/**
			 * 준비중인 컨텐츠가 있을 경우 안내후 닫기
			 */
			if ( self.contentList.length > self.answerList.length ) {

				self.swalUtils.gritter( "다음 강의는 준비중입니다.", "다음 강의는 준비중입니다. \r\n다음 강의 오픈시 알려드리겠습니다.", "info" )
					.then(() => {
						if ( opener != null ) {
							self.appClose({
								reload: true
							})
						} else {
							history.back()
						}
					})
				return;
			}

			self.$eventBus.$emit("startProgress")
			this.axiosCaller.put(this, this.APIs.EDU_STUDENT + "/complete", {
				emIdx: this.eduMain.emIdx,
				userId: this.getLoginId(),
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data;

				if ( result.status === "ok" ) {

					self.swalUtils.gritter( "교육완료", "교육 이수가 완료되었습니다.", "info" )
						.then(() => {

							if ( opener != null ) {
								self.appClose({
									reload: true
								})
							} else {
								history.back()
							}
						})
				}

			})
		},



		isNext () {

			if ( this.contentList.length > this.step + 1 ) {
				return true
			} else {
				return false
			}
		},



		goPrev () {

			if ( 0 <= this.step - 1 ) {
				this.step--;
			} else {

			}

		},

		doClose () {
			this.appClose({
				reload: true,
			})
		},

	}
}
</script>

<style scoped>
	.learning-close {
		width: 100%;
		height: 40px;
		position: relative;
	}

	.close-box {
		cursor: pointer;
		position: absolute;
		right: 0;
		top: 0;
		margin-top: 5px;
		width: 30px; height: 30px;
		background-image: url(/ssflex/assets/img/common/ico_close.svg);
		background-repeat: no-repeat;
		background-position: center;
	}

	@media (max-width: 767px) {
		/*
		.inner {
			display: flex;
		}
		.learning-title {
			padding: 20px;
			margin-left: 5px;
		}
		.learning-title .text-box {
			width: 100%;
		}
		.learning-title .thumb-box {
			width: calc(20% - 8px);
			margin: auto 20px auto 0;
		}
		*/
		.learning-title .info-row {
			padding: 0 0 0 90px;
		}
	}

	@media (max-width: 575px){
		.learning-close {
			width: 100%;
			height: 40px;
			margin-bottom: 50px;
		}

		/*
		.learning-title {
			padding: 10px 20px;
			margin-left: 5px;
			margin-right: 5px;
		}
		.learning-title .inner .text-box {
			width: 100%;
		}
		.learning-title .inner .text-box .tit{
			font-size: 20px;
		}
		*/
		.learning-title .info-row {
			font-size: 13px;
			padding: 0 0 0 90px;
			display: flex;
		}
		.learning-title .thumb-box {
			/*width: calc(20% - px);*/
			margin: auto 20px auto 0;
		}
	}

</style>
